import type { ServiceRequestInterface } from '@src/domain/types';
import type { MapperInterface } from '@src/server/converters/types/mapper.interface';
import type { AzureSubscriptionContextModuleInterface } from '@src/domain/types/azure-subscription-context-module.interface';
import { ServiceRequestPost, ServiceRequestPostRequest } from 'cmp-client-api';

const transformToApiModel = (
  model: AzureSubscriptionContextModuleInterface
): ServiceRequestPostRequest => ({
  module: model.selectedModule,
  title: model.title,
  requestType: model.requestType,
  description: model.description,
  deploysServiceModule: model.deploysServiceModule,
  inputs: model.inputs,
  deploymentContext: model.deploymentContext,
});

export const ServiceRequestAndAzureSubscriptionContextMapper: MapperInterface<
  AzureSubscriptionContextModuleInterface,
  ServiceRequestPostRequest
> = { transformToApiModel };

const transformServiceRequestPostToServiceRequest = ({
  data: apiModelData,
}: ServiceRequestPost): ServiceRequestInterface => ({
  ...apiModelData,
  supportSystem: apiModelData.serviceNow,
});

export const ServiceRequestPostAndServiceRequestInterfaceMapper: MapperInterface<
  ServiceRequestInterface,
  ServiceRequestPost
> = {
  transformFromApiModel: transformServiceRequestPostToServiceRequest,
};
